import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaLink,
  FaHandHoldingUsd,
  FaAddressBook
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer
      className="text-light pt-5"
      style={{
        background: "linear-gradient(90deg, #111 0%, #222 100%)"
      }}
    >
      <div className="container">
        <div className="row">

          {/* Company Info */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h4 className="text-info fw-bold mb-3">
              Finbasket
            </h4>
            <p className="text-muted fcolor">
              Finbasket makes borrowing simple with fast, flexible, and transparent loans built around your needs
            </p>

            <div className="d-flex gap-3 mt-4">
              <div className="bg-primary rounded-circle p-3">
                <FaFacebookF />
              </div>
              <div className="bg-info rounded-circle p-3">
                <FaInstagram />
              </div>
              <div className="bg-danger rounded-circle p-3">
                <FaYoutube />
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="fw-bold mb-3">
              <FaLink className="me-2 text-info" />
              Quick Links
            </h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                → <Link to="/" className="text-light text-decoration-none">Home</Link>
              </li>
              <li className="mb-2">
                → <Link to="/about-us" className="text-light text-decoration-none">About Us</Link>
              </li>
              <li className="mb-2">
                → <Link to="/blogs" className="text-light text-decoration-none">Blogs</Link>
              </li>
              <li className="mb-2">
                → <Link to="/contact-us" className="text-light text-decoration-none">Contact</Link>
              </li>
              <li className="mb-2">
                → <Link to="/faqs" className="text-light text-decoration-none">FAQs</Link>
              </li>
              <li className="mb-2">
                → <Link to="/emi-calculator" className="text-light text-decoration-none">EMI Calculator</Link>
              </li>
            </ul>
          </div>

          {/* Loan Services */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="fw-bold mb-3">
              <FaHandHoldingUsd className="me-2 text-info" />
              Loan Services
            </h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                → <Link to="/home-loan" className="text-light text-decoration-none">Home Loan</Link>
              </li>
              <li className="mb-2">
                → <Link to="/personal-loan" className="text-light text-decoration-none">Personal Loan</Link>
              </li>
              <li className="mb-2">
                → <Link to="/business-loan" className="text-light text-decoration-none">Business Loan</Link>
              </li>
              <li className="mb-2">
                → <Link to="/property-loan" className="text-light text-decoration-none">Property Loan</Link>
              </li>
              <li className="mb-2">
                → <Link to="/education-loan" className="text-light text-decoration-none">Education Loan</Link>
              </li>
              <li className="mb-2">
                → <Link to="/car-loan" className="text-light text-decoration-none">Car Loan</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="fw-bold mb-3">
              <FaAddressBook className="me-2 text-info" />
              Contact Info
            </h5>

            <p className="fcolor">
              <FaMapMarkerAlt className="me-2 text-info" />
              Hyderabad, Telangana
            </p>
            <p className="fcolor">
              <FaPhoneAlt className="me-2 text-info" />
              +91 9XXXXXXXXX
            </p>
            <p className="fcolor">
              <FaEnvelope className="me-2 text-info" />
              info@meloans.com
            </p>
            <p className="fcolor">
              <FaClock className="me-2 text-info" />
              10am to 6pm, Sunday Holiday
            </p>
          </div>
        </div>

        <hr className="border-secondary" />

        {/* Bottom Bar */}
        <div className="d-flex flex-column flex-md-row justify-content-between pb-3">
          <p className="mb-2 mb-md-0 text-muted">
            © 2025 Finbasket. All rights reserved.
          </p>

          <div className="d-flex gap-3">
            <Link to="/privacy-policy" className="text-muted text-decoration-none">
              Privacy Policy
            </Link>
            &nbsp; | &nbsp;
            <Link to="/terms-of-service" className="text-muted text-decoration-none">
              Terms of Service
            </Link>
            &nbsp; | &nbsp;
            <Link to="/disclaimer" className="text-muted text-decoration-none">
              Disclaimer
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
